import React, { useRef, useState } from "react";
import { Move } from "lucide-react";

export function Spin360({ src, testId }: { src: string; testId: string }) {
  const v = useRef<HTMLVideoElement>(null);
  const drag = useRef<{ x: number; t: number } | null>(null);
  const [hint, setHint] = useState(true);
  const down = (e: React.PointerEvent) => { const el = v.current; if (!el) return; el.pause(); drag.current = { x: e.clientX, t: el.currentTime }; (e.target as HTMLElement).setPointerCapture(e.pointerId); setHint(false); };
  const move = (e: React.PointerEvent) => {
    const el = v.current; const d = drag.current;
    if (!el || !d || !el.duration) return;
    const w = (e.currentTarget as HTMLElement).clientWidth;
    let t = (d.t + ((e.clientX - d.x) / w) * el.duration) % el.duration;
    if (t < 0) t += el.duration;
    el.currentTime = t;
  };
  const up = () => { drag.current = null; };
  return (
    <div className="relative select-none touch-none cursor-grab active:cursor-grabbing bg-neutral-950" onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerCancel={up} data-testid={testId}>
      <video ref={v} src={src} muted playsInline loop autoPlay preload="auto" className="w-full aspect-square object-contain pointer-events-none" />
      {hint && <span className="absolute bottom-4 left-1/2 -translate-x-1/2 inline-flex items-center gap-2 bg-black/60 text-white px-4 py-2 text-[10px] uppercase tracking-[0.2em]"><Move size={12} />Drag to spin</span>}
    </div>
  );
}
